import React from 'react';
import classnames from 'classnames';
import MaterialIconButton from '@material-ui/core/IconButton';
import styles from './IconButton.scss';

const IconButton = React.forwardRef(({ className, ...props }, ref) =>
    <MaterialIconButton
        className={classnames(className, styles.iconButton)}
        { ...props }
        ref={ref}
    />);

IconButton.displayName = 'IconButton';

export default IconButton;
